(function () {
  function cleanWords(str) {
    return (str || "").trim().replace(/\s+/g, " ");
  }

  function countWords(str) {
    const cleaned = cleanWords(str);
    if (!cleaned) return 0;
    return cleaned.split(" ").length;
  }

  function initGiftBlock(root) {
    if (root.dataset.mbGiftInitialised === "true") return;
    root.dataset.mbGiftInitialised = "true";

    const enable = root.querySelector(".mb-gift-enable");
    const panel = root.querySelector(".mb-gift-panel");
    const wrap = root.querySelector(".mb-box-fields");
    const genErr = root.querySelector(".mb-general-error");

    if (!enable || !panel || !wrap) return;

    const genericImg = root.dataset.genericImg || "";
    const blankImg = root.dataset.valentinesImg || "";
    const productFormId = root.dataset.productFormId || "";

    let form = null;

    if (productFormId) {
      form = document.getElementById(productFormId);
    }

    if (!form) {
      const productPage = root.closest("product-page");

      if (productPage) {
        form = productPage.querySelector(
          'form[data-type="add-to-cart-form"]'
        );
      }
    }

    if (!form) {
      console.warn(
        "Mindful Bakery gift message: product form could not be found."
      );
      return;
    }

    function getQuantityInput() {
      return form.querySelector('input[name="quantity"]');
    }

    function getQty() {
      const qtyInput = getQuantityInput();

      const q = qtyInput
        ? parseInt(qtyInput.value || "1", 10)
        : 1;

      return isNaN(q) || q < 1 ? 1 : q;
    }

    function buildBoxes() {
      const qty = getQty();

      wrap.innerHTML = "";

      for (let i = 1; i <= qty; i++) {
        const gImg = genericImg
          ? `<img src="${genericImg}" alt="Generic card">`
          : `<div>Generic</div>`;

        const bImg = blankImg
          ? `<img src="${blankImg}" alt="Blank card">`
          : `<div>Blank</div>`;

        const box = document.createElement("div");
        box.className = "mb-box-block";

        box.innerHTML = `
          <strong>Gift Card for Box ${i}</strong>

          <div class="mb-card-grid">

            <label class="mb-card-tile">
              <input
                type="radio"
                name="mb_card_${root.dataset.mbGiftBlock}_${i}"
                value="Generic"
                data-is-blank="false"
                hidden
              >

              <div class="mb-card-inner">
                ${gImg}
                <div class="mb-card-name">Generic</div>
              </div>
            </label>

            <label class="mb-card-tile">
              <input
                type="radio"
                name="mb_card_${root.dataset.mbGiftBlock}_${i}"
                value="Blank"
                data-is-blank="true"
                hidden
              >

              <div class="mb-card-inner">
                ${bImg}
                <div class="mb-card-name">Blank</div>
              </div>
            </label>

          </div>

          <div class="mb-card-error" hidden>
            Please choose a card design.
          </div>

          <div class="mb-message-fields">

            <label
              style="
                display:block;
                margin-top:12px;
                margin-bottom:5px;
                font-weight:600;
              "
            >
              To:
            </label>

            <input
              type="text"
              class="mb-gift-to"
              placeholder="Recipient's name"
              style="
                width:100%;
                padding:10px;
                border-radius:10px;
                border:1px solid rgba(0,0,0,.2);
              "
            >

            <label
              style="
                display:block;
                margin-top:12px;
                margin-bottom:5px;
                font-weight:600;
              "
            >
              Message:
            </label>

            <textarea
              class="mb-gift-message"
              rows="3"
              placeholder="Write your message (max 30 words)"
              style="
                width:100%;
                padding:10px;
                border-radius:10px;
                border:1px solid rgba(0,0,0,.2);
              "
            ></textarea>

            <div
              style="
                display:flex;
                justify-content:space-between;
                font-size:12px;
                margin-top:6px;
              "
            >
              <span class="wc">30 words remaining</span>

              <span class="mb-msg-error" hidden>
                Too many words
              </span>
            </div>

            <label
              style="
                display:block;
                margin-top:12px;
                margin-bottom:5px;
                font-weight:600;
              "
            >
              From:
            </label>

            <input
              type="text"
              class="mb-gift-from"
              placeholder="Your name"
              style="
                width:100%;
                padding:10px;
                border-radius:10px;
                border:1px solid rgba(0,0,0,.2);
              "
            >

          </div>
        `;

        wrap.appendChild(box);

        const tiles = box.querySelectorAll(".mb-card-tile");

        const radios = box.querySelectorAll(
          'input[type="radio"]'
        );

        const messageFields =
          box.querySelector(".mb-message-fields");

        const messageInput =
          box.querySelector(".mb-gift-message");

        const toInput =
          box.querySelector(".mb-gift-to");

        const fromInput =
          box.querySelector(".mb-gift-from");

        const wc =
          box.querySelector(".wc");

        const msgErr =
          box.querySelector(".mb-msg-error");

        tiles.forEach((tile, idx) => {
          tile.addEventListener("click", () => {
            const selectedRadio = radios[idx];

            selectedRadio.checked = true;

            tiles.forEach((t) =>
              t.classList.remove("is-active")
            );

            tile.classList.add("is-active");

            const error =
              box.querySelector(".mb-card-error");

            if (error) {
              error.hidden = true;
            }

            const isBlank =
              selectedRadio.getAttribute(
                "data-is-blank"
              ) === "true";

            if (messageFields) {
              messageFields.hidden = isBlank;
            }

            if (isBlank) {
              if (messageInput) {
                messageInput.value = "";
              }

              if (toInput) {
                toInput.value = "";
              }

              if (fromInput) {
                fromInput.value = "";
              }

              if (wc) {
                wc.textContent =
                  "30 words remaining";
              }

              if (msgErr) {
                msgErr.hidden = true;
              }
            }
          });
        });

        messageInput.addEventListener("input", () => {
          const words =
            countWords(messageInput.value);

          const remaining =
            Math.max(0, 30 - words);

          wc.textContent =
            `${remaining} words remaining`;

          msgErr.hidden =
            !(words > 30);
        });
      }
    }

    enable.addEventListener("change", () => {
      panel.hidden = !enable.checked;

      if (genErr) {
        genErr.hidden = true;
      }

      if (enable.checked) {
        buildBoxes();
      } else {
        wrap.innerHTML = "";
      }
    });

    form.addEventListener("change", (event) => {
      if (
        enable.checked &&
        event.target.matches(
          'input[name="quantity"]'
        )
      ) {
        buildBoxes();
      }
    });

    form.addEventListener("input", (event) => {
      if (
        enable.checked &&
        event.target.matches(
          'input[name="quantity"]'
        )
      ) {
        buildBoxes();
      }
    });

    async function addOne(variantId, props) {
      const response = await fetch(
        window.Shopify?.routes?.root
          ? window.Shopify.routes.root +
              "cart/add.js"
          : "/cart/add.js",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },

          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: props
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          "Gift message product could not be added."
        );
      }

      return response.json();
    }

    form.addEventListener(
      "submit",
      async function (event) {
        if (!enable.checked) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const currentVariantInput =
          form.querySelector(
            'input[name="id"]'
          );

        const variantId =
          currentVariantInput?.value;

        if (!variantId) {
          console.error(
            "Mindful Bakery gift message: variant ID missing."
          );
          return;
        }

        const qty = getQty();

        let hasError = false;

        for (let i = 1; i <= qty; i++) {
          const box =
            wrap.children[i - 1];

          if (!box) {
            hasError = true;
            continue;
          }

          const selectedCard =
            box.querySelector(
              'input[type="radio"]:checked'
            );

          const design =
            selectedCard?.value || "";

          const isBlank =
            selectedCard?.getAttribute(
              "data-is-blank"
            ) === "true";

          const messageInput =
            box.querySelector(
              ".mb-gift-message"
            );

          const message =
            cleanWords(
              messageInput?.value || ""
            );

          const cardError =
            box.querySelector(
              ".mb-card-error"
            );

          const msgError =
            box.querySelector(
              ".mb-msg-error"
            );

          if (cardError) {
            cardError.hidden = !!design;
          }

          if (msgError) {
            msgError.hidden =
              isBlank ||
              !(countWords(message) > 30);
          }

          if (
            !design ||
            (!isBlank &&
              countWords(message) > 30)
          ) {
            hasError = true;
          }
        }

        if (hasError) {
          if (genErr) {
            genErr.hidden = false;
          }

          return;
        }

        if (genErr) {
          genErr.hidden = true;
        }

        const submitButton =
          form.querySelector(
            '[type="submit"][name="add"], [data-js-product-add-to-cart]'
          );

        if (submitButton) {
          submitButton.disabled = true;
        }

        try {
          for (let i = 1; i <= qty; i++) {
            const box =
              wrap.children[i - 1];

            const selectedCard =
              box.querySelector(
                'input[type="radio"]:checked'
              );

            const design =
              selectedCard.value;

            const isBlank =
              selectedCard.getAttribute(
                "data-is-blank"
              ) === "true";

            let message;

            if (isBlank) {
              message =
                "Leave blank – customer to write";
            } else {
              const to =
                cleanWords(
                  box.querySelector(
                    ".mb-gift-to"
                  ).value
                );

              const body =
                cleanWords(
                  box.querySelector(
                    ".mb-gift-message"
                  ).value
                );

              const from =
                cleanWords(
                  box.querySelector(
                    ".mb-gift-from"
                  ).value
                );

              message =
                `To: ${to} | Message: ${body} | From: ${from}`;
            }

            await addOne(variantId, {
              "Card design": design,
              "Gift message": message,
              "Box": String(i)
            });
          }

          window.location.href =
            window.Shopify?.routes?.root
              ? window.Shopify.routes.root +
                  "cart"
              : "/cart";

        } catch (error) {
          console.error(error);

          if (submitButton) {
            submitButton.disabled = false;
          }

          if (genErr) {
            genErr.textContent =
              "Sorry, there was a problem adding your gift message. Please try again.";

            genErr.hidden = false;
          }
        }
      },
      true
    );
  }

  function initAllGiftBlocks() {
    document
      .querySelectorAll(
        "[data-mb-gift-block]"
      )
      .forEach(initGiftBlock);
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initAllGiftBlocks
    );
  } else {
    initAllGiftBlocks();
  }

  document.addEventListener(
    "shopify:section:load",
    initAllGiftBlocks
  );
})();